module.exports = __webpack_public_path__ + "static/img/logo.a8d5d30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = dLd/
// module chunks = 71